import { Schema as S } from "effect";

export const DeleteScheduleRequestSchema = S.Struct({
  _id: S.String,
});

export type DeleteScheduleRequest = S.Schema.Type<typeof DeleteScheduleRequestSchema>;
